<div class="d-flex gap-2 flex-wrap">
    <div *ngFor="let o of options">
        <div class="d-flex align-items-center">
            <label
                [for]="'fabrication-method_options_item' + o.value + ''"
                class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
            >
                <p-radioButton
                    [inputId]="'fabrication-method_options_item' + o.value + ''"
                    [value]="o.value"
                    [ngModel]="selectionModel.selected[0]"
                    (ngModelChange)="selectionModel.select($event); onTouchedFn?.()"
                    name="fabrication-methods-select"
                />
                <span>{{ o.label }}</span>
            </label>
        </div>
    </div>
    <div *ngIf="showNone">
        <div class="d-flex align-items-center">
            <label
                [for]="'fabrication-method_options_item_none'"
                class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
            >
                <p-radioButton
                    [inputId]="'fabrication-method_options_item_none'"
                    [value]="null"
                    [ngModel]="selectionModel.selected[0]"
                    (ngModelChange)="selectionModel.select($event); onTouchedFn?.()"
                    name="fabrication-methods-select"
                />
                <span>无</span>
            </label>
        </div>
    </div>
</div>
